var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content h_iframe"},[_c('iframe',{attrs:{"frameborder":"0","allowfullscreen":"","src":_vm.iframe_url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }